import { School } from '../school';
export class NewsArticle {
    constructor(
        public id?: number,
        public title?: string,
        public content?: string,
        public validSince?: any,
        public validUntil?: any,
        public showInHomePage?: boolean,
        public showInLessonListPage?: boolean,
        public school?: School,
    ) {
        this.showInHomePage = false;
        this.showInLessonListPage = false;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/news-article/news-article.model.ts